import { render } from "./EnUnit4-4.vue?vue&type=template&id=333efc68&scoped=true"
import script from "./EnUnit4-4.vue?vue&type=script&lang=js"
export * from "./EnUnit4-4.vue?vue&type=script&lang=js"

import "../assets/css/en-common.css?vue&type=style&index=0&id=333efc68&scoped=true&lang=css"
import "../assets/css/en/Unit4-4.css?vue&type=style&index=1&id=333efc68&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333efc68"]])

export default __exports__